export default __webpack_public_path__ + "static/logo-prime-video-bd74c67b126cafe83e4b39cd245eeb9b.png";